import Button from "@app/components/button"
import GradientContainer from "@app/components/gradient/gradient-container"
import ScheduleDemo from "@app/components/schedule-demo";

const DesktopFindYourPlan = () => (
  <div className="w-full flex justify-center">
    <GradientContainer
      overrideClassName="py-10 px-12 xl:p-16 w-[80%] absolute
       lg:-mt-24 xl:-mt-36 w-full rounded-2xl"
    >
      <div className="flex flex-row justify-between items-center w-full">
        <div className="flex h3 xl:h2 text-light flex-col">
          <p>Find your plan.</p>
          <p>Explore our options.</p>
        </div>
        <div>
          <ScheduleDemo>
            {(setIsModalOpen) =>
              <Button
                buttonType="base"
                size="3xl"
                onClick={() => setIsModalOpen(true)}>Schedule Demo
              </Button>
            }
          </ScheduleDemo>
        </div>
      </div>
    </GradientContainer>
  </div>
)

export default DesktopFindYourPlan;